import { render, staticRenderFns } from "./RecargoShowData.vue?vue&type=template&id=bf00b974&"
import script from "./RecargoShowData.vue?vue&type=script&lang=js&"
export * from "./RecargoShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports